// The unallocated list on Engineer Dispatch.
// Every job with no visit is shown, whatever day the board is open on.
// Search matches the job number, customer, site, type and description.
// Sort is by the date the job was created, or by job type.

function jobType(job) {
  return String((job && (job.job_category || job.job_type)) || '').trim();
}

function createdTime(job) {
  const time = new Date(job && job.created_at).getTime();
  return Number.isFinite(time) ? time : 0;
}

function matchesSearch(job, query) {
  const needle = String(query || '').trim().toLowerCase();
  if (!needle) return true;
  const haystack = [
    job.job_number,
    job.company_name,
    job.customer_name,
    job.site_name,
    job.job_description,
    job.job_category,
    job.job_type,
    job.call_priority,
  ].filter(Boolean).join(' ').toLowerCase();
  return haystack.includes(needle);
}

function visibleUnallocated(jobs, query, sort) {
  const list = (Array.isArray(jobs) ? jobs : []).filter((job) => matchesSearch(job, query));
  list.sort((a, b) => {
    if (sort === 'type') {
      const byType = jobType(a).localeCompare(jobType(b), undefined, { sensitivity: 'base' });
      if (byType !== 0) return byType;
    }
    if (sort === 'created-asc') return createdTime(a) - createdTime(b) || Number(a.id) - Number(b.id);
    return createdTime(b) - createdTime(a) || Number(b.id) - Number(a.id);
  });
  return list;
}

module.exports = {
  visibleUnallocated,
};
